import { useState } from "react";
import { NavLink } from "react-router-dom";
import { NavLink as RouteLink } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import LogoutButton from "./LogoutButton";
import { MenuToggle } from "./MenuToggle";

const NavLinksContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const LinksWrapper = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  height: 100%;
  list-style: none;
  background-color: #fff;
  width: 100%;
  flex-direction: column;
  position: fixed;
  top: 65px;
  padding-top: 20px;
  left: 0;
  z-index: 999;
`;

const LinkItem = styled.li`
  width: 100%;
  padding: 0 1.1em;
  color: #222;
  font-weight: 500;
  font-size: 16px;
  display: flex;
  justify-content: center;

  margin-bottom: 10px;
`;

const Link = styled(RouteLink)`
  text-decoration: none;
  color: inherit;
  font-size: inherit;
`;

const Marginer = styled.div`
  height: 2em;
`;

const OutsideLinkItem = styled.div`
  height: 100%;
  padding: 0 0.8em 0 0;
  color: #222;
  font-weight: 500;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  display: flex;

  a {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .active {
    border-bottom: 3px solid #559ed6;
  }
`;

export function MobileNavLinks() {
  const [isOpen, setOpen] = useState(false);

  const { t } = useTranslation();
  return (
    <NavLinksContainer>
      <OutsideLinkItem>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/demo"
        >
          {t("demoPage")}
        </NavLink>
      </OutsideLinkItem>
      <MenuToggle isOpen={isOpen} toggle={() => setOpen(!isOpen)} />
      {isOpen && (
        <LinksWrapper>
          <LinkItem>
            <Link to="/demo" onClick={() => setOpen(false)}>
              {t("demoPage")}
            </Link>
          </LinkItem>
          <LinkItem>
            <Link to="/account" end onClick={() => setOpen(false)}>
              {t("personPage")}
            </Link>
          </LinkItem>
          <LinkItem>
            <Link to="/panel" onClick={() => setOpen(false)}>
              {t("controlPanel")}
            </Link>
          </LinkItem>
          <LinkItem>
            <Link onClick={() => setOpen(false)} to="/analytic">
              {t("analyticPage")}
            </Link>
          </LinkItem>
          <LinkItem>
            <Link to="/storybook" onClick={() => setOpen(false)}>
              Storybook
            </Link>
          </LinkItem>
          <Marginer />
          <LogoutButton />
        </LinksWrapper>
      )}
    </NavLinksContainer>
  );
}
